module.exports = __webpack_public_path__ + "img/icon-pix-purple.9f8d93d4.svg";